module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"email":"Seu e-mail:","title":"Insira sua nova senha e confirme ela","busy":"Atualizando senha","login":"Ir para página de Login","action":"Mudar senha","call":"Ainda não possuo cadastro.","register":"Cadastre-se agora.","success":"Senha recuperada com sucesso!","token":"Token de recuperação de senha","password":{"label":"Informe sua nova senha:","type":{"text":"Mostrar","password":"Esconder"},"confirmation_label":"Confirme sua senha nova:"}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Auth/Password.vue
// module id = 134
// module chunks = 0